import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../config";
import "./card1.css";

const Card1 = () => {
  const fullText = "BLOG DETAILS";
  const typingSpeed = 150;
  const [typedText, setTypedText] = useState("");
  console.log("typedText:", typedText);
  const { id } = useParams();
  const [blogDetails, setBlogDetails] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const relativeDate = location.state?.relativeDate;
  const currentPage = location.state?.page || 1;

  // Typing effect
  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
      setTypedText(fullText.substring(0, index + 1));
      index++;
      if (index === fullText.length) clearInterval(interval);
    }, typingSpeed);
    return () => clearInterval(interval);
  }, []);

  // Fetch blog data
  useEffect(() => {
    const fetchBlog = async () => {
      try {
        setLoading(true);
        const blogResponse = await axios.get(`${BASE_URL}/blogs_ai4bazaar/${id}`);
        let blogData = blogResponse.data;
        console.log("Fetched blog data:", blogData);

        if (typeof blogData.content === "string") {
          try {
            blogData.content = JSON.parse(blogData.content);
            console.log("Parsed content:", blogData.content);
          } catch (parseError) {
            console.error("Error parsing content:", parseError);
            setError("Invalid content format.");
            setLoading(false);
            return;
          }
        }

        if (!Array.isArray(blogData.content)) {
          console.error("Content is not an array:", blogData.content);
          setError("Content must be an array.");
          setLoading(false);
          return;
        }

        const imageResponse = await axios.get(`${BASE_URL}/blogs_ai4bazaar/${id}/image`, {
          responseType: "blob",
        });
        const reader = new FileReader();
        reader.onloadend = () => {
          setImageSrc(reader.result);
          console.log("Image loaded as base64");
        };
        reader.readAsDataURL(imageResponse.data);

        setBlogDetails(blogData);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching blog:", err);
        setError("Failed to load blog details.");
        setLoading(false);
      }
    };

    fetchBlog();
  }, [id]);

  const handleBackToList = () => {
    navigate(`/page/${currentPage}`, { state: { page: currentPage } });
  };

  const cleanContent = (content) => {
    if (typeof content !== "string") return content;
    return content.replace(/^[:\s]+/, "").replace(/[:\s]+$/, "").trim();
  };

  if (loading) return <div className="loading-container"><p className="loading-text">Loading...</p></div>;
  if (error) return <div className="error-container"><p className="error-text">{error}</p></div>;
  if (!blogDetails) return <div className="not-found-container"><p className="not-found-text">Blog not found.</p></div>;

  const { title, admin, date, content } = blogDetails;

  const renderContent = () => {
    const elements = [];
    let listItems = [];

    content.forEach((item, index) => {
      console.log(`Rendering item ${index}:`, item);
      const cleanedContent = cleanContent(item.content);

      if (item.type === "text" || item.type === "paragraph") {
        if (listItems.length > 0) {
          elements.push(
            <ul key={`list-${index}`} className="content-list">
              {listItems}
            </ul>
          );
          listItems = [];
        }
        elements.push(
          <p
            key={index}
            className="content-text"
            style={{ fontFamily: "'Ubuntu', Arial, sans-serif" }}
          >
            {cleanedContent}
          </p>
        );
      } else if (item.type === "heading") {
        if (listItems.length > 0) {
          elements.push(
            <ul key={`list-${index}`} className="content-list">
              {listItems}
            </ul>
          );
          listItems = [];
        }
        elements.push(
          <h2
            key={index}
            className="content-heading"
            style={{ fontFamily: "'Ubuntu', Arial, sans-serif", fontWeight: "400", color: "rgb(21, 1, 29)" }}
          >
            {cleanedContent}
          </h2>
        );
      } else if (item.type === "heading1") {
        const nextItem = content[index + 1];
        const nextContent = nextItem && nextItem.type === "text1" ? cleanContent(nextItem.content) : "";
        listItems.push(
          <li
            key={index}
            className="content-list-item"
            style={{ fontFamily: "'Ubuntu', Arial, sans-serif", color: "rgb(21, 1, 29)" }}
          >
            <span className="content-bold">{cleanedContent}</span>
            {nextContent && (
              <span
                className="content-list-text"
                style={{ fontFamily: "'Ubuntu', Arial, sans-serif" }}
              >
                {nextContent}
              </span>
            )}
          </li>
        );
      } else if (item.type === "text1") {
        // Skip text1 as it's handled with heading1
      } else if (item.type === "heading2") {
        if (listItems.length > 0) {
          elements.push(
            <ul key={`list-${index}`} className="content-list">
              {listItems}
            </ul>
          );
          listItems = [];
        }
        elements.push(
          <h3
            key={index}
            className="content-subheading"
            style={{ fontFamily: "'Ubuntu', Arial, sans-serif", color: "rgb(21, 1, 29)" }}
          >
            {cleanedContent}
          </h3>
        );
      } else if (item.type === "text2") {
        if (listItems.length > 0) {
          elements.push(
            <ul key={`list-${index}`} className="content-list">
              {listItems}
            </ul>
          );
          listItems = [];
        }
        elements.push(
          <p
            key={index}
            className="content-text"
            style={{ fontFamily: "'Ubuntu', Arial, sans-serif", color: "rgb(21, 1, 29)" }}
          >
            {cleanedContent}
          </p>
        );
      } else if (item.type === "urllink") {
        if (listItems.length > 0) {
          elements.push(
            <ul key={`list-${index}`} className="content-list">
              {listItems}
            </ul>
          );
          listItems = [];
        }
        elements.push(
          <a
            key={index}
            href={item.linktag}
            target="_blank"
            rel="noopener noreferrer"
            className="content-link"
            style={{ fontFamily: "'Ubuntu', Arial, sans-serif", color: "rgb(21, 1, 29)" }}
          >
            {cleanedContent}
          </a>
        );
      } else {
        console.warn(`Unknown content type: ${item.type}`);
      }
    });

    if (listItems.length > 0) {
      elements.push(
        <ul key="list-final" className="content-list">
          {listItems}
        </ul>
      );
    }

    return elements;
  };

  return (
    <>
      {/* Preload Ubuntu font */}
      <link
        href="https://fonts.googleapis.com/css2?family=Ubuntu:wght@300;400;500;600;700&display=swap"
        rel="stylesheet"
      />

      {/* Blog Header */}
      <div>


        {/* Blog Content */}
        <div className="blog-container">
          <div className="blog-detail-content">
            {imageSrc && (
              <div className="image-container">
                <img
                  src={imageSrc}
                  alt={title}
                  className="blog-image blog-imagedetails"
                />
              </div>
            )}
            <div className="blog-title-container">
              <h2 className="blog-post-title">
                {title}
              </h2>
              <p className="blog-post-meta">
                👤- By {admin} • 🗓️ {relativeDate || new Date(date).toLocaleDateString()}
              </p>
            </div>

            {/* Render content */}
            <div className="content-container">{renderContent()}</div>
          </div>
        </div>

        {/* Back Button */}
        <div className="button-container">
          <button
            type="button"
            className="back-button"
            onClick={handleBackToList}
          >
            Back to List
          </button>
        </div>
      </div>
    </>
  );
};

export default Card1;